export const OPEN_ID = 'openId'

export const setOpenId = (openId) => {
    window.localStorage.setItem(OPEN_ID, openId)
}

export const getOpenId = () => {
    return window.localStorage.getItem(OPEN_ID)
}